import { useQuery } from '@tanstack/react-query';
import { estimateHeadersService } from '../services/estimateHeaders.service';

export function useEstimateDetail(estimateId?: string) {
  const query = useQuery({
    queryKey: ['estimates', 'detail', estimateId],
    queryFn: () => estimateHeadersService.getById(estimateId!),
    enabled: !!estimateId,
  });

  return {
    estimate: query.data || null,
    isLoading: query.isLoading,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
